import { render, staticRenderFns } from "./PersonGrid.vue?vue&type=template&id=0320b997&scoped=true"
import script from "./PersonGrid.vue?vue&type=script&lang=js"
export * from "./PersonGrid.vue?vue&type=script&lang=js"
import style0 from "./PersonGrid.vue?vue&type=style&index=0&id=0320b997&prod&scoped=true&lang=css"
import style1 from "./PersonGrid.vue?vue&type=style&index=1&id=0320b997&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0320b997",
  null
  
)

export default component.exports